// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.charjs-custom{background:transparent;max-width:100%}
`, "",{"version":3,"sources":["webpack://./src/views/Client/Dashboard/Chart/ChartJs/styles.scss"],"names":[],"mappings":"AAAA,eACE,sBAAuB,CACvB,cAAe","sourcesContent":[".charjs-custom {\n  background: transparent;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
